import { api } from "./helpers";
import { HttpService } from "../ducks/http/HttpService";
import { UserRole } from "./roles";

const httpService = new HttpService(`${api}`);

export type { UserRole };

export interface SystemUser {
  _id: string;
  username: string;
  role: UserRole;
  createdAt?: string;
  tokenFromFlashDrive?: string;
}

class UsersService {
  async getUsersList(): Promise<SystemUser[]> {
    return await httpService.get<SystemUser[]>("/users");
  }

  async createUser(props: {
    username: string;
    password: string;
    role: UserRole;
    tokenFromFlashDrive?: string;
  }): Promise<SystemUser> {
    return await httpService.post<SystemUser>("/users", props);
  }

  async deleteUser(id: string): Promise<{ success: boolean }> {
    return await httpService.delete<{ success: boolean }>(`/users/${id}`);
  }
}

export default new UsersService();
